import React, { useEffect } from "react";
import { isNative, initMobileApp } from "../utils/capacitor";

interface MobileWrapperProps {
  children: React.ReactNode;
}

const MobileWrapper: React.FC<MobileWrapperProps> = ({ children }) => {
  useEffect(() => {
    if (isNative) {
      initMobileApp();
    }
  }, []);

  return <>{children}</>;
};

export default MobileWrapper;
